module.exports = __webpack_public_path__ + "img/p3_14.db12a407.webp";